const settings = {
  btnSave: 'Editar',
  off: 'Desligado',
  btnRestoreDefault: 'Restaurar as configurações padrão',

  btnAdvance: {
    show: 'Mostrar avançado',
    hide: 'Ocultar avançado',
  },

  general: {
    title: 'Geral',
    pageTitle: 'Configurações Gerais',
    groups: {
      general: {
        title: 'Geral',
        parameters: {
          timezone: {
            label: 'Fuso horário',
            description: 'O sistema',
          },
          defaultLanguage: {
            label: 'Idioma padrão',
            description:
              'Idioma preferido – será aplicado ao alterar a visualização do site, atualizar ou fazer login, se nenhuma preferência do usuário for definida.',
          },
          systemType: {
            label: 'Tipo de sistema',
            description: 'Alternar entre unidades imperiais e métricas para personalizar a exibição de distâncias no sistema.',
            options: {
              imperial: 'Imperial',
              metric: 'Métrico',
            },
          },
          addressType: {
            label: 'Tipo de campo de endereço',
            description:
              'Personalize como os endereços são preenchidos. "Google" permite preenchimento automático pelo Google, "Local" preenche automaticamente os locais salvos no sistema.',
            options: {
              both: 'Both',
              google: 'Google',
              location: 'Location',
            },
          },
          enableLocationTimezone: {
            label: 'Ativar fuso horário por local',
            description:
              'Quando ativado, o sistema resolve o fuso horário a partir do local da reserva em vez de usar o fuso horário padrão do sistema.',
          },
        },
      },
      auth: {
        title: 'Autenticação',
        parameters: {
          twoFA: {
            label: 'Exigir autenticação de dois fatores (2FA)',
            description: 'Quando ativado, todos os usuários devem realizar a autenticação de dois fatores em dispositivos novos.',
          },
        },
      },
      booking: {
        title: 'Reserva',
        parameters: {
          preventDuplications: {
            label: 'Aviso de duplicação de reserva',
            description:
              'Ative para receber um aviso ao preencher uma reserva com detalhes idênticos ou desative para desativar este alerta.',
          },
          isWaitAndReturnEnabled: {
            label: 'Habilitar Espera e Retorno',
            description: '',
          },
        },
      },
      map: {
        title: 'Mapa',
        parameters: {
          mapStyle: {
            label: 'Estilo dos Mosaicos do Mapa',
            description: 'Escolha a imagem dos mosaicos usada em todos os mapas da plataforma',
            options: {
              lightDark: 'Claro / Escuro',
              streets: 'Ruas',
              satellite: 'Satélite',
            },
          },
          mapServer: {
            label: 'Servidor de Mapas',
            description: 'Servidor de Mapas OSRM',
          },
          graphhopperEnabled: {
            label: 'Ativar Graphhopper',
            description:
              'Quando ativado, o sistema usa o Graphhopper como servidor de mapas para roteamento. Quando desativado, o OSRM é usado.',
          },
          mapCenter: {
            label: 'Centro do Mapa',
            description: 'Defina o ponto central padrão para a visualização do mapa.',
          },
          mapZoom: {
            label: 'Zoom do Mapa',
            description: 'O zoom padrão para mapas na plataforma.',
          },
        },
      },
    },
  },
  routing: {
    title: 'Roteirização',
    pageTitle: 'Configurações de Roteirização',
    groups: {
      base: {
        title: 'Base',
        parameters: {
          sharedRideRatio: {
            label: 'Proporção Máxima de Tempo Partilhado',
            description:
              'Proporção máxima permitida entre o tempo de viagem a solo e o tempo de viagem partilhado (ex.: 1,5 = até 50% mais longo do que a viagem a solo)',
          },
          sharedRideDifferenceLimit: {
            label: 'Tempo Extra Máximo Partilhado ',
            description:
              'Número máximo de minutos que podem ser adicionados ao tempo da viagem a solo quando o passageiro está numa viagem partilhada',
          },
          maxSharedDistanceRatio: {
            label: 'Proporção Máxima de Distância Partilhada',
            description:
              'Define quanto uma viagem partilhada pode ser mais longa em comparação com a distância a solo. Exemplo: Se a distância a solo é 1 milha e a proporção é 1,2x, a viagem partilhada não pode exceder 1,2 milhas',
          },
          maxTripStops: {
            label: 'Paradas Máximas',
            description: 'Número máximo de locais de parada por viagem.',
          },
          maxPickupStops: {
            label: 'Máximo de Paradas para Embarque',
            description: 'Número máximo de paradas para embarque por viagem.',
          },
          maxDropoffStops: {
            label: 'Máximo de Paradas para Desembarque',
            description: 'Número máximo de paradas para desembarque por viagem.',
          },
          maxTripDuration: {
            label: 'Duração Máxima',
            description: 'Duração máxima de uma viagem em minutos.',
          },
          maxSinglePassengerTime: {
            label: 'Tempo Máximo de Viagem para Passageiro Único',
            description: '',
          },
          maxPassengers: {
            label: 'Passageiros Máximos',
            description: 'Número máximo de passageiros durante toda a viagem.',
          },
          maxPassengersAtOnce: {
            label: 'Passageiros Máximos ao Mesmo Tempo',
            description:
              'Número máximo de passageiros permitidos ao mesmo tempo (um assento estará livre/usado durante o desembarque/embarque).',
          },
          tripBoardingTime: {
            label: 'Tempo de Embarque',
            description: 'O tempo necessário para pegar um passageiro em sua parada (este parâmetro impactará a duração total da viagem).',
          },
          subsequentPickTime: {
            label: 'Tempo de Embarque Secundário',
            description: 'Quando esta configuração está desativada, os tempos de embarque seguem o geral.',
          },
          tripDropOffTime: {
            label: 'Tempo de Desembarque',
            description: 'O tempo necessário para deixar um passageiro em sua parada (este parâmetro impactará a duração total da viagem).',
          },
          subsequentDropOffTime: {
            label: 'Tempo de Desembarque Secundário',
            description: 'Quando esta configuração está desativada, os tempos de desembarque seguem o geral.',
          },
          maxBoardingDelay: {
            label: 'Atraso Máximo no Embarque',
            description: 'Número máximo de minutos que um motorista pode se atrasar em relação ao horário de embarque definido na reserva.',
          },
          maxBoardingEarly: {
            label: 'Adiantamento Máximo no Embarque',
            description:
              'Número máximo de minutos que um motorista pode se adiantar em relação ao horário de embarque definido na reserva.',
          },
          onlyPrivate: {
            label: 'Somente Privado',
            description: 'Tornar todas as viagens privadas',
          },
        },
      },
      advanced: {
        title: 'Avançado',
        parameters: {
          tripsJoinMode: {
            label: 'Tentar Combinar',
            description: 'Não Juntar = 0, Tentar Juntar = 1, Somente Juntar = 2',
            options: {
              dontJoin: 'Não Juntar',
              tryJoin: 'Tentar Juntar',
              onlyJoin: 'Somente Juntar',
            },
          },
          maxJoinRadius: {
            label: 'Tentar Combinar - Raio',
            description: 'Define o raio máximo em que tentamos buscar viagens existentes para combinar com uma reserva.',
          },
          maxJoinTimeRange: {
            label: 'Tentar Combinar - Intervalo de Tempo',
            description: 'Viagens existentes que estejam além deste limite serão consideradas para tentativa de combinação.',
          },
          maxReservationsAtOnce: {
            label: 'Máximo de Reservas Simultâneas',
            description: 'Número máximo de reservas permitidas no veículo ao mesmo tempo.',
          },
          minReservationDistance: {
            label: 'Distância Mínima da Reserva',
            description:
              'Distância mínima (em metros) que uma reserva deve ter entre a embarque e desembarque para ser incluída na rota. Reservas com uma distância menor serão completamente ignoradas pelo sistema.',
          },
          maxEmptyTripTime: {
            label: 'Tempo Máximo Vazio',
            description: 'Número máximo de minutos que uma viagem pode permanecer vazia entre as paradas.',
          },
          maxDropOffEarly: {
            label: 'Adiantamento Máximo na Entrega',
            description:
              'Número máximo de minutos que um motorista pode se adiantar em relação ao horário de desembarque definido na reserva.',
          },
          maxDropOffDelay: {
            label: 'Atraso Máximo na Entrega',
            description:
              'Número máximo de minutos que um motorista pode se atrasar em relação ao horário de desembarque definido na reserva.',
          },
          pickPhaseRadius: {
            label: 'Intervalo de Raio Embarque',
            description:
              'Define a distância máxima permitida (em metros) entre o primeiro embarque e os subsequentes. Reservas com embarque fora deste raio não serão combinadas.',
          },
          pickPhaseMinutes: {
            label: 'Intervalo de Minutos Embarque',
            description:
              'Define o tempo máximo (em minutos) permitido entre o primeiro embarque e os subsequentes. Se a diferença de tempo exceder este limite, as reservas não serão combinadas.',
          },
          groupWaitAndReturn: {
            label: 'Agrupar Espera e Retorno',
            description:
              '• Desligado: Nenhum agrupamento; viagens de ida e retorno são roteadas separadamente.\n\n• Par Individual Agrupar cada viagem de ida e retorno em uma única viagem.\n\n• Múltiplos Pares Agrupar vários pares de ida e retorno juntos, permitindo que vários pares de espera e retorno sejam roteados em uma única viagem.',
            options: {
              off: 'Desligado',
              individualPair: 'Agrupamento de Par Individual',
              multiplePairs: 'Agrupamento de Múltiplos Pares',
            },
          },
          pickupAllBeforeDropping: {
            label: 'Recolher Todos',
            description:
              'Quando definido como verdadeiro, a viagem irá primeiro recolher todos os passageiros e, em seguida, começar a deixá-los.',
          },
          waitForBoardingTime: {
            label: 'Aguardar Tempo de Embarque',
            description: 'Ao chegar em uma parada, o motorista aguardará até o horário exato de embarque, se necessário.',
          },
          sortStopsByPickupTime: {
            label: 'Ordenar por Tempo de Coleta',
            description:
              'Quando definido como verdadeiro, todas as paradas da viagem serão ordenadas apenas pelo horário de coleta e não geograficamente.',
          },
          balanceDepartureTime: {
            label: 'Normalizar Saída',
            description: 'Ajusta o horário de saída para que o passageiro',
          },
          angleDuration: {
            label: 'Duração do Ângulo',
            description:
              'Evita a roteirização de trechos que durem mais minutos do que a duração do ângulo e estejam em um ângulo maior que o especificado..',
          },
          angleMax: {
            label: 'Ângulo Máximo',
            description:
              'Evita a roteirização de trechos que durem mais minutos do que a duração do ângulo e estejam em um ângulo maior que o especificado.',
          },
          allowActiveTripsRouteChanges: {
            label: 'Adicionar Reservas a Viagens em Andamento',
            description:
              "Ativar reservas 'Tentar Juntar' (ex.: Chamadas de Última Hora) para viagens em andamento junto com novas viagens.",
          },
          rerouteTripOnBookingUpdate: {
            label: 'Roteirizar Viagem de Novo ao Atualizar Reserva',
            description:
              'Quando ativado, uma reserva editada permanece na sua viagem. Uma viagem no status Novo é roteirizada de novo: a reserva permanece se ainda couber com as outras reservas, e o motorista permanece se ainda for elegível. Uma viagem no status Enviado/Aprovado/Em rota também é roteirizada de novo, então suas paradas podem receber uma nova ordem e novos horários, e todas as suas reservas permanecem. Viagens no status Ok/Cancelado nunca são alteradas. Quando desativado, a reserva editada é removida da viagem e volta ao status Novo, a não ser que esteja Recolhido/Deixado/No Show - então ela permanece e a viagem é roteirizada de novo com ela.',
          },
          vrpRunningTime: {
            label: 'Tempo de execução do VRP',
            description:
              'Limite de tempo para a otimização tentar melhorar os resultados; execuções mais longas permitem explorar mais possibilidades.',
          },
          editOnMap: {
            label: 'Editar no Mapa',
            description: 'Permite que os usuários reordenem manualmente as paradas dentro de uma viagem arrastando-as no mapa.',
          },
          consistentPassengerRouting: {
            label: 'Roteamento Consistente de Passageiros',
            description:
              'Garante que o mesmo grupo de passageiros siga sempre a mesma rota de e para o endereco especifico, otimizando a eficiencia da viagem e minimizando confusao.',
          },
          sameDriverForGroup: {
            label: 'Mesmo Motorista para o Grupo',
            description:
              'Atribui o mesmo motorista para transportar o grupo de passageiros tanto na coleta quanto na entrega, proporcionando familiaridade e consistencia.',
          },
          routingMode: {
            label: 'Modo de roteamento',
            description: '',
            options: {
              default: 'Padrão',
              hClustering: 'H-Clustering',
              vrp: 'VRP',
            },
          },
          defaultWillCallTime: {
            label: 'Deslocamento de Tempo Padrão do Will Call',
            description:
              'Adicionar X minutos à lógica de deslocamento do Will Call como padrão quando não houver atributo relacionado ao Will Call',
          },
          enableWillCallTime: {
            label: 'Horário de Will Call ativado',
          },
        },
      },
      sameAreaLocation: {
        title: 'Mesma zona / Localização',
        parameters: {
          mergeReservationsByBoardingArea: {
            label: 'Mesma zona de Embarque',
            description: 'As reservas serão agrupadas apenas se a localização de embarque estiver no mesmo polígono.',
          },
          mergeReservationsByBoardingLocation: {
            label: 'Mesma Localização de Embarque',
            description: 'As reservas serão agrupadas apenas se a localização de embarque for a mesma.',
          },
          mergeReservationsByDropArea: {
            label: 'Mesma zona de Desembarque',
            description: 'As reservas serão agrupadas apenas se a localização de desembarque estiver no mesmo polígono.',
          },
          mergeReservationsByDropLocation: {
            label: 'Mesma Localização de Desembarque',
            description: 'As reservas serão agrupadas apenas se a localização de desembarque for a mesma.',
          },
          onlyGroupExactLocations: {
            label: 'Mesma Localização de Embarque ou Desembarque',
            description: 'As reservas serão agrupadas apenas se as localizações de embarque ou desembarque forem as mesmas.',
          },
          snapToLocation: {
            label: 'Ajustar à Localização',
            description:
              'Ajustar automaticamente a origem ou destino da reserva para a localização conhecida mais próxima do nosso módulo de gerenciamento de localizações internas, se estiver dentro do raio snapToLocation. O valor está em metros/pés com base no formato de configuração do sistema.',
          },
          sameFlightNumber: {
            label: 'Mesmo número de voo',
            description: 'As reservas serão agrupadas apenas se o número do voo for o mesmo.',
          },
        },
      },
      evs: {
        title: 'Veículos Elétricos',
        parameters: {
          minimalBatteryThreshold: {
            label: 'Limite Mínimo de Bateria',
            description:
              'Esta é a porcentagem crítica de bateria que você não deseja que o sistema fique abaixo durante sua viagem. Por exemplo, se definido como 30%, o sistema tentará manter sua bateria acima desse nível.',
          },
        },
      },
      reservationClusters: {
        title: 'Agrupamento de Reservas',
        parameters: {
          isClusteringEnabled: {
            label: 'Agrupamento',
            description: 'Define se os algoritmos de agrupamento de reservas estão ativados ou não.',
          },
          clusterSnapTo: {
            label: 'Modo',
            description: 'Define se o endereço do centro do cluster deve ser alterado para uma estrada conhecida ou uma estação de ônibus.',
            options: {
              address: 'Endereço',
              busStop: 'Ponto de Ônibus',
            },
          },
          clusterReservationsRadius: {
            label: 'Diâmetro',
            description: 'Em qual diâmetro começar a combinar reservas em um único ponto de embarque/desembarque',
          },
          clusterSnapMaxDistance: {
            label: 'Distância Máxima',
            description:
              'Distância máxima (em KM/Milhas, conforme o sistema definido) na qual o endereço do centro do cluster pode ser modificado para uma localização melhor.',
          },
          snapToShapeRatio: {
            label: 'Paradas/Aglomerados Prioritários por Distância Aérea',
            description:
              'O sistema tentará criar paradas adicionais ao longo da rota se a distância aérea do passageiro for menor que a proporção selecionada.',
          },
          snapToShapeUnite: {
            label: 'Distância Mínima Entre Paradas Geradas',
            description: 'Distância mínima entre as paradas criadas.',
          },
          distanceType: {
            label: 'Tipo de Distância',
            description: 'Define se a distância até o agrupamento será medida por Distância Aérea ou a Pé',
            options: {
              airDistance: 'Distância Aérea',
              walkingDistance: 'Distância a Pé',
            },
          },
          maxPassengersInCluster: {
            label: 'Número Máximo de Passageiros no Agrupamento',
            description:
              'Número máximo de passageiros permitido em um agrupamento. Esta configuração continua editável mesmo quando o agrupamento está desativado.',
          },
          keepVrpClusters: {
            label: 'Manter Agrupamentos do VRP',
            description:
              'Quando ativado, a saída do VRP permanece agrupada. Quando desativado, os agrupamentos do VRP são divididos em reservas individuais para roteamento novamente.',
          },
        },
      },
      smoothRoute: {
        title: 'Rota Suave',
        parameters: {
          smoothRouteEnabled: {
            label: 'Rota Suave',
            description:
              'Define se o endereço central do agrupamento deve ser alterado para uma rua conhecida, ponto de ônibus ou por Rota Suave.',
          },
          smoothRouteRadius: {
            label: 'Raio da Rota Suave',
            description:
              'Define a distância máxima de caminhada (em metros) que um passageiro pode ser solicitado a caminhar quando a "Rota Suave" está ativada. Esta configuração só entra em vigor se a "Rota Suave" estiver ativada.',
          },
        },
      },
      traffic: {
        title: 'Tráfego',
        parameters: {
          trafficRouteEnabled: {
            label: 'Editar configurações de tráfego',
            modalHeader: 'Aviso: Configurações sensíveis de tráfego',
            modalBody:
              'Você está prestes a editar configurações avançadas de tráfego. Esses valores afetam diretamente como as rotas são calculadas e podem alterar significativamente o comportamento do sistema. Por favor, prossiga somente se entender completamente as implicações. Para confirmar, digite "traffic" abaixo e clique em "Confirmar".',
          },
          minTraffic: {
            label: 'Mínimo',
            description: 'Proporção mínima entre a duração do tráfego e a duração do servidor de mapas',
          },
          baseTraffic: {
            label: 'Base',
            description:
              'Multiplica todas as durações calculadas por uma razão base (X). Valores maiores aumentam os tempos de viagem estimados.',
          },
          hourTraffic: {
            label: 'Hora',
            description:
              'Um array de 24 razões horárias (00:00–23:59). Cada valor ajusta os multiplicadores de duração da viagem com base na hora do dia.',
          },
        },
      },
    },
  },
  assignment: {
    title: 'Atribuição de Motorista',
    pageTitle: 'Configurações de Atribuição de Motorista',
    groups: {
      base: {
        title: 'Base',
        parameters: {
          distanceFromTripScore: {
            label: 'Distância',
            description: 'Dê maior prioridade se desejar aumentar as chances de que o motorista mais próximo da viagem seja atribuído.',
          },
          timeFromTripScore: {
            label: 'Tempo',
            description:
              'Dê maior prioridade se desejar aumentar as chances de que o motorista que pode chegar mais rápido ao ponto de partida seja atribuído.',
          },
          gapTimeScore: {
            label: 'Inatividade',
            description:
              'Uma prioridade maior aumentará as chances de que um motorista que está esperando há mais tempo por seu próximo trabalho seja atribuído.',
          },
          ifTripDone: {
            label: 'Número de Viagens',
            description:
              'Quanto maior a prioridade, maiores as chances de que alguém já atribuído seja atribuído novamente. Dê menor prioridade para equilibrar as viagens entre motoristas ativos e maior prioridade para ter a menor quantidade de motoristas necessária.',
          },
          perTripDone: {
            label: 'Por Viagem Concluída',
            description: 'Quanto maior a prioridade, mais cada viagem concluída aumenta as chances do motorista ser atribuído novamente.',
          },
          accumulatedSalaryScore: {
            label: 'Ganhos',
            description:
              'Dê alta prioridade se desejar equilibrar a quantidade de motoristas com base nos seus salários (usando o maior número de motoristas). Dê baixa prioridade se desejar usar a menor quantidade de motoristas.',
          },
          algorithmCode: {
            label: 'Código do Algoritmo',
            options: {
              dateOrdering: 'Ordenação por Data',
              dynamicOrdering: 'Ordenação Dinâmica',
            },
          },
          driverAssignmentStrategy: {
            label: 'Estratégia de Atribuição de Motoristas',
            options: {
              minimumFleetUsage: 'Uso Mínimo da Frota',
              balanceAvailableDrivers: 'Balanceamento – Motoristas Disponíveis',
              balanceMinimumRequiredDrivers: 'Balanceamento – Motoristas Mínimos Necessários',
            },
          },
        },
      },
      limits: {
        title: 'Limites',
        parameters: {
          maxTripsPerDriver: {
            label: 'Máximo de Viagens',
            description: 'A quantidade máxima de viagens que um motorista pode ser atribuído em uma solicitação específica.',
          },
          maxAccumulatedSalary: {
            label: 'Preço Máximo',
            description:
              'A soma máxima do salário que um motorista pode ganhar no processo de atribuição (e outros motoristas terão prioridade).',
          },
        },
      },
      advanced: {
        title: 'Configurações Avançadas',
        parameters: {
          distanceFromHomeScore: {
            label: 'Distância da Casa',
            description: 'Se você deseja manter os motoristas próximos de casa (sua localização inicial), deve dar alta prioridade.',
          },
          nextTripDistanceScore: {
            label: 'Distância da Próxima Viagem',
            description:
              'Quando "preenchemos lacunas" no meio do cronograma de um motorista, priorizamos com base na distância da próxima viagem.',
          },
          idleBonusMinutes: {
            label: 'Minutos de Bônus por Inatividade',
            description: 'Período que o motorista precisa permanecer inativo para receber o bônus de ${}.',
          },
          idleBonusScore: {
            label: 'Pontuação de Bônus por Inatividade',
            description: 'A quantidade de pontos adicionada à pontuação do motorista após permanecer inativo por ${} minutos.',
          },
          scorePerEmptySeats: {
            label: 'Por Assento Vazio',
            description:
              'Use esta configuração para especificar sua preferência por minimizar os assentos vazios no veículo (quanto mais negativo o valor, maior será a evasão).',
          },
          assignPriorityBonusMax: {
            label: 'Bônus de Prioridade de Regras Personalizadas – Máximo',
            description: 'Pontuação máxima concedida ao atributo de maior prioridade ao atribuir viagens',
          },
          assignPriorityBonusMin: {
            label: 'Bônus de Prioridade de Regras Personalizadas – Mínimo',
            description: 'Pontuação mínima concedida ao atributo de menor prioridade ao atribuir viagens',
          },
          areaMatchScore: {
            label: 'Correspondência de zona',
            description: 'Quanto maior a prioridade, maior a probabilidade de um motorista pertencente à zona da viagem ser atribuído.',
          },
          scorePerVehicleCost: {
            label: 'Custo por Veículo',
            description: '',
          },
          perAssignmentScore: {
            label: 'Pontuação por atribuição',
            description:
              'Adiciona uma pontuação para cada viagem atribuída a um motorista. Valores mais altos desincentivarão a atribuição de múltiplas viagens ao mesmo motorista.',
          },
          perLoadedDistance: {
            label: 'Pontuação por distância carregada',
            description:
              'Adiciona uma pontuação com base na distância das viagens com passageiros (milhas carregadas). Valores mais altos priorizam viagens mais curtas e reduzem a distância total carregada.',
          },
          isAssignBlocked: {
            label: 'Bloquear Atribuição Automática',
            description: 'Quando a Atribuição Automática estiver desativada, os perfis selecionados não serão atribuídos automaticamente.',
          },
          assignBlockedProfiles: {
            label: 'Perfis Bloqueados',
            description: 'Escolha quais perfis não devem ser atribuídos automaticamente pela plataforma.',
          },
          assignBlockedAttributes: {
            label: 'Atributos Bloqueados',
            description: 'Escolha quais atributos não devem ser atribuídos automaticamente pela plataforma.',
          },
          allowFlexibleTimes: {
            label: 'Permitir Horários Flexíveis',
            description:
              'Otimize as atribuições de motoristas e reduza o uso de veículos modificando os horários de partida das viagens, respeitando as regras de atraso e adiantamento máximo no embarque.',
          },
          unassignOnVehicleChange: {
            label: 'Desativar desatribuição de motorista na troca de veículo',
            description:
              'Alterar um motorista para outro veículo com atributos correspondentes de "Correspondência de Atributos de Reserva de Motorista/Veículo" não desatribuirá automaticamente a viagem do motorista.',
          },
          consistentSupplier: {
            label: 'Fornecedor Consistente',
            description:
              'O sistema atribuirá motoristas do mesmo fornecedor às reservas de um passageiro dentro de um único dia, desconsiderando as limitações do motorista.',
          },
          assignBySupplier: {
            label: 'Atribuir por Fornecedor',
            description: '',
          },
          supplierPriorityMode: {
            label: 'Ordem do Fornecedor',
            description: '',
            options: {
              byRank: 'Por Classificação',
              byTier: 'Por Nível',
            },
          },
          shiftAllocationWeight: {
            label: 'Disponibilidade do Motorista',
            description: 'Quantidade de pontos adicionada à pontuação do motorista por duração do turno',
          },
        },
      },
      driverShifts: {
        title: 'Turnos de Motorista',
        parameters: {
          ignoreDriverShifts: {
            label: 'Ignorar Turnos de Motorista',
            description: 'O processo de atribuição de motoristas considera os turnos dos motoristas.',
          },
          startShiftWithTrip: {
            label: 'Iniciar Turno com Viagem',
            description:
              'Atribui motoristas a viagens no início de seus turnos sem considerar o tempo de deslocamento até a primeira coleta. Os motoristas são responsáveis por chegar ao local inicial de coleta pontualmente no início do turno.',
          },
          maxShiftHours: {
            label: 'Tempo Máximo de Turno',
            description:
              'A duração máxima (em horas) de um turno de motorista. O sistema não permitirá que um motorista seja considerado ativo por mais do que esse tempo.',
          },
          shiftGap: {
            label: 'Intervalo entre Turnos',
            description: 'Defina a duração obrigatória do intervalo entre turnos consecutivos.',
          },
          driverRestAfterTrip: {
            label: 'Exigir Intervalo',
            description: 'Os motoristas são solicitados a fazer uma pausa após cada viagem.',
          },
          ignoreDropoffTime: {
            label: 'Ignorar Horário de Desembarque',
            description: 'O sistema atribuirá viagens aos motoristas mesmo se o horário de desembarque estiver fora da disponibilidade deles.',
          },
          shiftBuffer: {
            label: 'Margem do Turno',
            description: 'Permite atribuir viagens que terminam até X minutos após o fim do turno.',
          },
        },
      },
      mobileApp: {
        title: 'Aplicativo de Turnos de Motoristas',
        parameters: {
          allowShiftCreation: {
            label: 'Permitir Criação de Turnos',
            description: 'Permitir que os motoristas criem novos turnos em sua programação.',
          },
          allowBreaksInShifts: {
            label: 'Permitir Intervalos nos Turnos',
            description: 'Permitir que os motoristas incluam períodos de intervalo dentro de seus turnos.',
          },
          enableShiftDeletion: {
            label: 'Permitir Exclusão de Turnos',
            description: 'Permitir que os motoristas excluam seus turnos agendados, se necessário.',
          },
          minimumShiftCancellationNotice: {
            label: 'Aviso Mínimo para Cancelamento de Turno',
            description: 'Definir o tempo mínimo necessário antes do início de um turno para que o motorista possa cancelá-lo.',
          },
          maxShiftAvailability: {
            label: 'Disponibilidade Máxima de Turno',
            description: 'Definir o maior período de disponibilidade que um motorista pode definir para si mesmo.',
          },
          enableRecurringShifts: {
            label: 'Permitir Turnos Recorrentes',
            description: 'Permitir que os motoristas criem turnos recorrentes em um intervalo de datas personalizado.',
          },
        },
      },
      virtualReal: {
        title: 'Virtual vs Real',
        parameters: {
          assignmentType: {
            label: 'Tipo de Atribuição',
            description: 'Modo de atribuição padrão (Motoristas reais vs Motoristas virtuais).',
            options: {
              virtual: 'Virtual',
              real: 'Real',
            },
          },
          addVirtualDrivers: {
            label: 'Preencher com Motoristas Virtuais',
            description: 'Atribui automaticamente motoristas virtuais às viagens quando não há motoristas reais disponíveis.',
          },
          defaultCarLocation: {
            label: 'Localização Padrão do Veículo',
            description: 'A localização de início padrão a ser considerada para um veículo/motorista, se não especificada.',
          },
          defaultCarSeats: {
            label: 'Assentos Padrão',
            description: 'Número padrão de assentos a ser considerado para um veículo, se não definido.',
          },
        },
      },
    },
  },
  distribution: {
    title: 'Distribuição',
    pageTitle: '',
    groups: {
      base: {
        title: 'Peso dos KPIs de Frotas',
        parameters: {
          onTimePerformance: {
            label: 'Pontualidade',
            description: '',
          },
          noShowRate: {
            label: 'Taxa de Não Comparecimento',
            description: '',
          },
          cancellationRate: {
            label: 'Taxa de Cancelamento',
            description: '',
          },
          acceptanceRate: {
            label: 'Taxa de Aceitação',
            description: '',
          },
          responseTime: {
            label: 'Tempo de Resposta',
            description: '',
          },
          costEfficiency: {
            label: 'Eficiência de Custos',
            description: '',
          },
        },
      },
    },
  },
  advancedSettingsPopups: {
    maxDurationByDistance: {
      title: 'Configurar Duração Máxima por Distância',
      form: {
        fields: {
          startKm: 'De ({{unit}})',
          endKm: 'Até ({{unit}})',
          durationMinutes: 'Duração Máxima (min)',
        },
        btnAddRange: 'Adicionar Intervalo',
        btnSubmit: 'Salvar',
        btnClose: 'Fechar',
      },
    },
  },
};

export default settings;
